import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowSplitLeft"><Path d="M10 5H6.41406L12.4141 11H21V13H12.4141L6.41406 19H10V21H3V14H5V17.5859L10.5859 12L5 6.41406V10H3V3H10V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowSplitLeft;
